module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultation"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "-mob-share-ui-bg"
  }), _vm._v(" "), _c('section', {
    staticClass: "part_1"
  }, [_c('h1', [_vm._v(_vm._s(_vm.new_content.title))]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('consultation_date')) + ":" + _vm._s(_vm.new_content.add_time))]), _vm._v(" "), _c('a', {
    staticClass: "right -mob-share-open",
    staticStyle: {
      "padding-left": "35px"
    },
    on: {
      "click": _vm.init
    }
  }, [_c('img', {
    staticClass: "right3",
    attrs: {
      "src": require("../../assets/home/share_normal.png"),
      "alt": "share",
      "width": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('consultation_Share')))])])]), _vm._v(" "), _c('div', {
    staticClass: "part_1_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.new_content.img,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.new_content.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "part_2"
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showThislike),
      expression: "showThislike"
    }]
  }, [_vm._v(_vm._s(_vm.$t('consultation_related_articles')))]), _vm._v(" "), _vm._l((_vm.new_list), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "relative_content"
    }, [_c('div', {
      staticClass: "relative_item1"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.detail(item.cms_id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "relative_item2"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.detail(item.cms_id)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  })], 2), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "-mob-share-ui",
    staticStyle: {
      "display": "none"
    }
  }, [_c('ul', {
    staticClass: "-mob-share-list"
  }, [_c('li', {
    staticClass: "-mob-share-weibo"
  }, [_c('p', [_vm._v("weibo")])]), _vm._v(" "), _c('li', {
    staticClass: "-mob-share-weixin"
  }, [_c('p', [_vm._v("wechat")])]), _vm._v(" "), _c('li', {
    staticClass: "-mob-share-google"
  }, [_c('p', [_vm._v("google+")])]), _vm._v(" "), _c('li', {
    staticClass: "-mob-share-pocket"
  }, [_c('p', [_vm._v("Pocket")])]), _vm._v(" "), _c('li', {
    staticClass: "-mob-share-facebook"
  }, [_c('p', [_vm._v("Facebook")])]), _vm._v(" "), _c('li', {
    staticClass: "-mob-share-twitter"
  }, [_c('p', [_vm._v("Twitter")])]), _vm._v(" "), _c('li', {
    staticClass: "-mob-share-tumblr"
  }, [_c('p', [_vm._v("Tumblr")])])]), _vm._v(" "), _c('div', {
    staticClass: "-mob-share-close"
  }, [_vm._v("Canel")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f29045d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/ConsultationDetails.vue
// module id = 863
// module chunks = 0